import { call, put, takeLatest, take } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import {
  FETCH_INCIDENT_JIRA_DATA,
  FETCH_INC_JIRA_LOADER,
  GET_INCIDENT_JIRA_DATA_URL,
  GET_ADD_COMMENT_URL,
  SET_JIRA_DATA,
  GET_CHANGE_STATUS_URL,
  CHANGE_STATUS,
  UPLOAD_FILES_COMMENT_REQUEST,
  UPLOAD_FILES_FAILURE,
  UPLOAD_FILES_PROGRESS,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_CHANGE_STATUS,
  ADD_COMMENT, ADD_COMMENT_SUCCESS, ADD_COMMENT_FAILURE,
} from '../../redux/constants/constants';
import axios from "axios";

function* fetchIncidentJiraData(action) {
  try {
    yield put({
      type: FETCH_INC_JIRA_LOADER,
      payload: { incLoader: true },
    });
    const res = yield getService({
      method: "GET",
      url: GET_INCIDENT_JIRA_DATA_URL(action.payload),
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: FETCH_INC_JIRA_LOADER,
        payload: { incLoader: false },
      });
      yield put({
        type: SET_JIRA_DATA,
        payload: { jiraData: res.data },
      });
    } else {
      yield put({
        type: FETCH_INC_JIRA_LOADER,
        payload: { incLoader: false },
      });
      yield put({
        type: SET_JIRA_DATA,
        payload: { jiraData: null },
      });
    }
  } catch (error) {
    yield put({
      type: FETCH_INC_JIRA_LOADER,
      payload: { incLoader: false },
    });
    yield put({
      type: SET_JIRA_DATA,
      payload: { jiraData: null },
    });
  }
}

function* changeStatusSaga(action) {
  try {
    yield put({
      type: FETCH_INC_JIRA_LOADER,
      payload: { incLoader: true },
    });
    const { files, ticketId, comment, transitionId, jiraId, oldStatus, newStatus, resolution } = action.payload;
    const formData = new FormData();
    files.forEach(file => {
      formData.append('file', file);
    });

    formData.append('payload', JSON.stringify({comment, transitionId, jiraId, oldStatus, newStatus, resolution}));

    // Create event channel for progress
    const progressChannel = createUploadProgressChannel(formData, files, ticketId, GET_CHANGE_STATUS_URL());

    while (true) {
      const { percent, fileName, done, error } = yield take(progressChannel);
      if (error) {
        yield put({
          type: ADD_COMMENT_FAILURE,
          payload: { success: false },
        });
        yield put({
          type: FETCH_INC_JIRA_LOADER,
          payload: { incLoader: false },
        });
        yield put({ type: UPLOAD_FILES_FAILURE, error });
        progressChannel.close();
        break;
      }
      if (done) {
        yield put({
          type: ADD_COMMENT_SUCCESS,
          payload: { success: true },
        });
        yield call(fetchIncidentJiraData, { payload: ticketId });
        yield put({
          type: FETCH_INC_JIRA_LOADER,
          payload: { incLoader: false },
        });
        yield put({ type: UPLOAD_FILES_SUCCESS });
        progressChannel.close();
        break;
      }
      yield put({ type: UPLOAD_FILES_PROGRESS, payload: { fileName, percent } });
    }
  } catch (error) {
    yield put({
      type: ADD_COMMENT_FAILURE,
      payload: { success: false },
    });
    yield put({
      type: FETCH_INC_JIRA_LOADER,
      payload: { incLoader: false },
    });
    yield put({ type: UPLOAD_FILES_FAILURE, error });
  }
}

function* uploadFilesComment(action) {
  try {
    yield put({
      type: FETCH_INC_JIRA_LOADER,
      payload: { incLoader: true },
    });
    const { files, comment, ticketId } = action.payload;
    const formData = new FormData();
    files.forEach(file => {
      formData.append('file', file);
    });
    formData.append('commentText', comment);

    // Create event channel for progress
    const progressChannel = createUploadProgressChannel(formData, files, ticketId, GET_ADD_COMMENT_URL(ticketId));

    while (true) {
      const { percent, fileName, done, error } = yield take(progressChannel);
      if (error) {
        yield put({
          type: ADD_COMMENT_FAILURE,
          payload: { success: false },
        });
        yield put({
          type: FETCH_INC_JIRA_LOADER,
          payload: { incLoader: false },
        });
        yield put({ type: UPLOAD_FILES_FAILURE, error });
        progressChannel.close();
        break;
      }
      if (done) {
        yield put({
          type: ADD_COMMENT_SUCCESS,
          payload: { success: true },
        });
        yield call(fetchIncidentJiraData, { payload: ticketId });
        yield put({
          type: FETCH_INC_JIRA_LOADER,
          payload: { incLoader: false },
        });
        yield put({ type: UPLOAD_FILES_SUCCESS });
        progressChannel.close();
        break;
      }
      yield put({ type: UPLOAD_FILES_PROGRESS, payload: { fileName, percent } });
    }
  } catch (error) {
    yield put({
      type: ADD_COMMENT_FAILURE,
      payload: { success: false },
    });
    yield put({
      type: FETCH_INC_JIRA_LOADER,
      payload: { incLoader: false },
    });
    yield put({ type: UPLOAD_FILES_FAILURE, error });
  }
}

// Helper: event channel for upload progress
function createUploadProgressChannel(formData, files, ticketId, url) {
  return eventChannel(emitter => {
    axios.post(url, formData, {
      headers: {
        ...getAxiosHeaders(true),
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (e) => {
        const total = e.total;
        const loaded = e.loaded;
        const percent = Math.round((loaded / total) * 100);
        // You can emit per file if needed, here just emit overall
        emitter({ percent, fileName: files[0]?.name || '', done: false });
      }
    }).then(() => {
      emitter({ done: true });
    }).catch(error => {
      emitter({ error });
    });
    // unsubscribe
    return () => { };
  });
}

export default function* incidentSidebarSaga() {
  yield takeLatest(FETCH_INCIDENT_JIRA_DATA, fetchIncidentJiraData);
  yield takeLatest(UPLOAD_FILES_CHANGE_STATUS, changeStatusSaga);
  yield takeLatest(UPLOAD_FILES_COMMENT_REQUEST, uploadFilesComment);
}